import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { login, passwordChanged } from '../state/auth.actions';

@Component({
    selector: 'app-password-change-required',
    templateUrl: './password-change-required.component.html',
    styleUrls: ['./password-change-required.component.scss']
})
export class PasswordChangeRequiredComponent implements OnInit {
    form!: UntypedFormGroup;

    oldPassword: string = '';
    passwordToConfirm: string = '';

    hide: boolean = true;

    isLoading: boolean = false;
    msg: MsgModel = {};

    constructor(
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.form = fb.group({
            oldPassword: ['', [Validators.required]],
            password: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {}

    changePassword() {
        if (this.form.valid) {
            this.isLoading = true;
            this.userProfileService.changePassword(this.form.get('oldPassword')?.value, this.form.get('password')?.value).subscribe((res) => {
                if (res.msg) {
                    this.msg = res.msg;
                    const userToken = res;

                    if (this.msg.SUCCESS) {
                        this.store.dispatch(login({ userToken }));
                        this.store.dispatch(passwordChanged());
                    } else {
                        this.isLoading = false;
                    }
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please check your inputs.' };
        }
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
